import {
  LIST_INFO_BOX_MULTI,
  EXCEL_LIST_INFO_BOX_MULTI,
  INSURANCE_BOX_MULTI,
  INFO_BOX_MULTI,
  PRICE_BOX_MULTI,
  WEIGHT_BOX_MULTI,
  SIZE_BOX_MULTI,
  LENGTH_BOX_MULTI,
  WIDTH_BOX_MULTI,
  HEIGHT_BOX_MULTI,
  AGENT_SERVICES_BOX_MULTI,
} from "../../Types";

export const setListBox = (payload) => {
  return {
    type: LIST_INFO_BOX_MULTI,
    payload: payload,
  };
};
export const setExcelListBox = (payload) => {
  return {
    type: EXCEL_LIST_INFO_BOX_MULTI,
    payload: payload,
  };
};
export const setInsuranceBox = (payload) => {
  return {
    type: INSURANCE_BOX_MULTI,
    payload: payload,
  };
};
export const setInfoBox = (payload) => {
  return {
    type: INFO_BOX_MULTI,
    payload: payload,
  };
};
export const setPriceBox = (payload) => {
  return {
    type: PRICE_BOX_MULTI,
    payload: payload,
  };
};
export const setWeightBox = (payload) => {
  return {
    type: WEIGHT_BOX_MULTI,
    payload: payload,
  };
};
export const setSizeBox = (payload) => {
  return {
    type: SIZE_BOX_MULTI,
    payload: payload,
  };
};
export const setLengthBox = (payload) => {
  return {
    type: LENGTH_BOX_MULTI,
    payload: payload,
  };
};
export const setWidthBox = (payload) => {
  return {
    type: WIDTH_BOX_MULTI,
    payload: payload,
  };
};
export const setHeightBox = (payload) => {
  return {
    type: HEIGHT_BOX_MULTI,
    payload: payload,
  };
};

export const setAgentServices = (payload) => {
  return {
    type: AGENT_SERVICES_BOX_MULTI,
    payload: payload,
  };
};
